module.exports = __webpack_public_path__ + "img/ios1icon8.d6fd9816.png";